import {
    IContactNode,
    IEntityContactSearchResultsById,
    IEntityNode, IEntitySearchResultNode,
    IEntityWithContactsNodeResult
} from "../types";
import {client} from "./client";
import gql from "graphql-tag";
import {SearchEntitiesAndContactsByLayerId} from "../../schema/SearchEntitiesAndContactsByLayerId";

type EntityWithContacts = Array<IEntityNode & {contacts: IContactNode[]}>

interface ISearchEntitiesAndContactsByLayerId_Query {
    search: string;
    layerIds: number[]
}

type ISearchEntitiesAndContactsByLayerId_Callback = (
    arg1: any,
    arg2?: any,
    arg3?: IEntitySearchResultNode[],
    arg4?: Date,
) => IEntityNode[]

export async function searchEntitiesAndContactsByLayerId (
    query: ISearchEntitiesAndContactsByLayerId_Query,
    callback: ISearchEntitiesAndContactsByLayerId_Callback
): Promise<IEntityNode[]> {
    try {
        // query.search = query.search.replace('%', '\\%');
        const options = {
            query: {
                ...gql`${SearchEntitiesAndContactsByLayerId}`,
                fetchPolicy: 'no-cache',
                errorPolicy: 'all',
            },
            variables: {
                search: query.search,
                layerIds: query.layerIds,
            }
        };
        const body: {data: IEntityContactSearchResultsById} = await client.query(options);
        return callback(null, {}, mapResults(body), new Date());
    } catch (e) {
        console.error(e);
        return callback(e);
    }
}

function mapNodeToFeature (node: IEntitySearchResultNode): IEntitySearchResultNode {
    const {
        name,
        membertype,
        websiteurl,
        notes,
        instruc,
        // optional
        description,
        datelastchanged,
        fullUid,
        geoType,
        layername,
        type,
    } = node;
    const properties = {
        name,
        membertype,
        websiteurl,
        notes,
        instruc,
        // optional
        description,
        datelastchanged,
        fullUid,
        geoType,
        layername,
        type,
    };
    return {...node, properties};
}


function mapNodeResults(nodes: ((IEntityNode & { contacts: IContactNode[] }) | IEntitySearchResultNode)[]): IEntitySearchResultNode[] {
    return nodes.map(node => mapNodeToFeature({
        ...node, ...node.layerByLayerid
    } as IEntitySearchResultNode))
}


function mapResults (response: {data: IEntityContactSearchResultsById}): IEntitySearchResultNode[] {
    const entityResults = response.data.searchEntitiesByLayerId.nodes.map(mapEntityNodes);
    const fullUids = new Set(entityResults.map(entity => entity.fullUid));
    const contactResults = getContactResults(response.data.searchContactsByLayerId.nodes, fullUids);
    const nodeResults = [...entityResults, ...contactResults];
    return mapNodeResults(nodeResults);
}

function getContactResults (nodes: IEntityContactSearchResultsById['searchContactsByLayerId']['nodes'],
                            fullUids: Set<string>): IEntitySearchResultNode[] {

    let results: any[] = [];
    const length = nodes.length;
    const filterFn = filterEntityNodes(fullUids);
    let i = -1;
    while (++i < length) {
        const node = nodes[i];
        const newEntities = node.entitycontactsByFullUid.nodes
            .filter(filterFn)
            .map(mapContactEntityNodes);
        results = results.concat(newEntities);
    }
    return results;
}

function filterEntityNodes (fullUids: Set<string>) {
    return function (node: {entityByFullUid: IEntityWithContactsNodeResult}): boolean {
        try {
            const isNewEntity = !fullUids.has(node.entityByFullUid.fullUid)
            if (isNewEntity) {
                fullUids.add(node.entityByFullUid.fullUid);
            }
            return isNewEntity;
        } catch (e) {
            console.warn(e);
            return false;
        }
    }
}

function mapEntityNodes (node: IEntityWithContactsNodeResult): EntityWithContacts[0] {
    return {
        ...node,
        contacts: node.entitycontactsByFullUid.nodes.map(
            node => node.contactByPocid
        )
    }
}

function mapContactEntityNodes (node: {entityByFullUid: IEntityWithContactsNodeResult}): EntityWithContacts[0] {
    return {
        ...node.entityByFullUid,
        contacts: node.entityByFullUid.entitycontactsByFullUid.nodes.map(
            node => node.contactByPocid
        )
    }
}
